module.exports = __webpack_public_path__ + "static/60invgde-c0323faccd2b4967398c11adcd7903c0.gif";